import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import { buttonsStyle, dateFormatter } from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { getMarcas } from "../../../../api/marca";
import {
  changeStatusModelo,
  deleteModelo,
  getModelos,
} from "../../../../api/modelo";
import FiltersCard from "../../../components/filters/Filter";
import {
  Button,
  CircularProgress,
  FormControlLabel,
  InputLabel,
  makeStyles,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Edit } from "@material-ui/icons";
import Table from "../../../components/customTable/Table";
import { shallowEqual, useSelector } from "react-redux";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

function getData(modelos) {
  let data = [];
  for (let i = 0; i < modelos.length; ++i) {
    const elem = {};
    elem.image = modelos[i]?.urlImage;
    elem.nombre = modelos[i]?.nombre;
    elem.materialCaja = modelos[i]?.materialCaja;
    elem.colorEsfera = modelos[i]?.colorEsfera;
    elem.diametro = modelos[i]?.diametro;
    elem.marca = modelos[i]?.marca?.nombre;
    elem.id = modelos[i]?._id;
    elem.sku = modelos[i]?.sku;
    elem.discountPercent = modelos[i]?.discountPercent ?? 0;
    elem.active = modelos[i]?.active;
    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  marcas: [],
  sku: "",
};
const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function ModelosPage() {
  const [data, setData] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const [modelo, setModelo] = useState(null);
  const [modeloId, setModeloId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const history = useHistory();
  const classes = useStyles();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [total, setTotal] = useState(0);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);

    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-modelo/" + cell)}
          >
            <Edit />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setModelo(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setModelo(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const resMarcas = await getMarcas();
        if (resMarcas.status === 200) {
          setMarcas(resMarcas.data);
          setLoading(false);
          setRefresh(false);
        } else {
          setLoading(false);
          alertError({ customMessage: "Could not get marcas." });
        }
        const resModelos = await getModelos({
          page,
          limit: pageSize,
          filters: filterOptions,
        });
        if (resModelos.status === 200) {
          setData(getData(resModelos.data.data));
          setTotal(resModelos.data.total);
          setLoading(false);
          setRefresh(false);
        } else {
          setLoading(false);
          alertError({ customMessage: "Could not get modelos." });
        }
      } catch (error) {
        setLoading(false);
        alertError({
          error: error,
          customMessage: "Could not get marcas o modelos.",
        });
      }
    };
    fetchData();
  }, [refresh, page, pageSize, filterOptions]);

  // function imageFormatter(imageURL) {
  //   return imageURL && imageURL.length > 1 ? (
  //     <img
  //       src={imageURL[0]}
  //       alt="property"
  //       style={{ width: "75px", cursor: "pointer" }}
  //       onClick={() => {
  //         setPreviewImage(imageURL);
  //         setOpenPreviewDialog(true);
  //       }}
  //       title="Click to view images"
  //     />
  //   ) : (
  //     <Tooltip title="No images available">
  //       <img
  //         src="/media/dummie-house.jpg"
  //         alt="No images available"
  //         style={{ width: "75px", cursor: "default" }}
  //       />
  //     </Tooltip>
  //   );
  // }

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: "idRef",
        accessor: "sku",
        disableFilters: true,
        getHeaderProps: () => {
          return {
            className: "custom-header",
          };
        },
        Cell: ({ value }) => (
          <span
            style={{
              display: "inline-block",
              flex: "1",
              whiteSpace: "wrap",
              textOverflow: "ellipsis",
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "Marca",
        accessor: "marca",
        disableFilters: true,
        getHeaderProps: () => ({
          className: "custom-header",
        }),
        Cell: ({ value }) => (
          <span
            style={{
              display: "inline-block",
              flex: "1",
              whiteSpace: "wrap",
              textOverflow: "ellipsis",
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "Descuento%",
        accessor: "discountPercent",
        disableFilters: true,
        getHeaderProps: () => ({ className: "custom-header" }),
        Cell: ({ value }) => (
          <span>{value != null ? `${value}%` : "0%"}</span>
        ),
      },
      {
        Header: "Nombre",
        accessor: "nombre",
        disableFilters: true,
        getHeaderProps: () => ({
          className: "custom-header",
        }),
        Cell: ({ value }) => (
          <span
            style={{
              display: "inline-block",
              flex: "1",
              whiteSpace: "wrap",
              textOverflow: "ellipsis",
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "Material Caja",
        accessor: "materialCaja",
        disableFilters: true,
        getHeaderProps: () => {
          return {
            className: "custom-header",
          };
        },
        filter: "includes",
      },
      {
        Header: "Color Esfera",
        accessor: "colorEsfera",
        disableFilters: true,
        getHeaderProps: () => {
          return {
            className: "custom-header",
          };
        },
        filter: "includes",
      },
      {
        Header: "Diametro",
        accessor: "diametro",
        disableFilters: true,
        getHeaderProps: () => {
          return {
            className: "custom-header",
          };
        },
        Cell: ({ value }) => (
          <span
            style={{
              display: "inline-block",
              flex: "1",
              whiteSpace: "wrap",
              textOverflow: "ellipsis",
            }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "",
        accessor: "id",
        disableFilters: true,
        width: 200,
        getHeaderProps: () => {
          return {
            className: "custom-header",
          };
        },
        Cell: ({ cell: { value } }) => buttonFormatter(value),
      },
    ];

    return baseColumns;
  }, [data]);

  const handleSearch = async () => { };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <>
        <div className="row d-flex align-items-center">
          <div className="col-md-6">
            <TextField
              id="sku"
              label="idRef"
              type="text"
              value={filterOptions.sku}
              onChange={(event) => {
                setFilterOptions({
                  ...filterOptions,
                  sku: event.target.value,
                });
              }}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="col-md-6">
            <Autocomplete
              className="w-100 mr-5"
              id="autocomplete-marca"
              filterSelectedOptions
              options={marcas}
              getOptionLabel={(option) => option?.nombre}
              value={filterOptions.marcas}
              onChange={(event, selected) => {
                setFilterOptions({ ...filterOptions, marcas: selected });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Marca"
                />
              )}
              multiple
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista Modelos">
          <CardHeaderToolbar>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-modelo")}
            >
              Add
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
          />
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <CircularProgress className={classes.fancyLoader} />
            </div>
          ) : (
            <Table
              data={data}
              columns={columns}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChange={setPage}
              onPageSizeChange={setPageSize}
            />
          )}
          <ConfirmDialog
            title={`Are you sure you want to ${modelo?.active ? "disable" : "enable"
              } this model?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusModelo(modeloId, modelo?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${modelo?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `Model ${modelo?.active ? "disabled" : "enabled"
                        } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${modelo?.active ? "disable" : "enable"
                      } model.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this model?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteModelo(modeloId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Model removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove model.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
